export function catchPaste(evt: Event | JQuery.Event, callback: (response: string) => void) {
    if (navigator.clipboard && navigator.clipboard.readText) {
        // modern approach with Clipboard API
        navigator.clipboard.readText().then(callback);
        // @ts-ignore
    } else if (evt.originalEvent && evt.originalEvent.clipboardData) {
        // @ts-ignore
        callback(evt.originalEvent.clipboardData.getData('text'));
        // @ts-ignore
    } else if (evt.clipboardData) {
        // @ts-ignore
        callback(evt.clipboardData.getData('text/plain'));
        // @ts-ignore
    } else if (window.clipboardData) {
        // @ts-ignore
        callback(window.clipboardData.getData('Text'));
    } else {
        throw new Error('Pasting capture is unavailable');
    }
}
